// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const TAB_BLOGS_ALL = "V\u0161etky";
export const TAB_BLOGS_POPULAR = "Popul\u00e1rne";
export const TAB_BLOGS_SUBSCRIBED = "Odober\u00e1m";
